export const getDocMeetinObjectivesInitialValues = () => [
  '• Objective 1',
  '• Objective 2',
  '• Objective 3',
]
